var _excluded = ["text", "url"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useState } from 'react';
import classnames from 'classnames';
import { Button } from "../../Button/Button/Button";
import { Text } from "../../Text/Text/Text";
import { CheckboxInput } from "../../Input/CheckboxInput/CheckboxInput";
import { Image } from "../../Image/Image/Image";
import styles from "./AddonCard.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AddonCard = function AddonCard(_ref) {
  var _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$statusMessage = _ref.statusMessage,
    statusMessage = _ref$statusMessage === void 0 ? '' : _ref$statusMessage,
    _ref$cta = _ref.cta,
    cta = _ref$cta === void 0 ? {
      text: '',
      url: ''
    } : _ref$cta,
    _ref$ribbonText = _ref.ribbonText,
    ribbonText = _ref$ribbonText === void 0 ? '' : _ref$ribbonText,
    _ref$version = _ref.version,
    version = _ref$version === void 0 ? 'ribbon' : _ref$version,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? {
      alt: '',
      src: ''
    } : _ref$image,
    _ref$checkbox = _ref.checkbox,
    checkbox = _ref$checkbox === void 0 ? {} : _ref$checkbox,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? '' : _ref$body,
    _ref$pillFlag = _ref.pillFlag,
    pillFlag = _ref$pillFlag === void 0 ? {
      text: '',
      bgColor: 'highlighter'
    } : _ref$pillFlag;
  var _useState = useState((checkbox === null || checkbox === void 0 ? void 0 : checkbox.checked) || false),
    _useState2 = _slicedToArray(_useState, 2),
    check = _useState2[0],
    setCheck = _useState2[1];
  var _ref2 = cta || {},
    ctaText = _ref2.text,
    ctaUrl = _ref2.url,
    ctaOtherProps = _objectWithoutProperties(_ref2, _excluded);
  var toggleCheckmark = function toggleCheckmark(onChange) {
    if (onChange) {
      onChange();
    }
    setCheck(!check);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.wrapper, {
      [styles.wrapperV2]: version === 'pillFlag'
    }),
    children: [version === 'pillFlag' && pillFlag.text && /*#__PURE__*/_jsx("span", {
      className: classnames(styles.pillFlag, {
        [styles.pillFlagKale]: pillFlag.bgColor === 'kale'
      }),
      children: pillFlag.text
    }), ribbonText && version !== 'pillFlag' && /*#__PURE__*/_jsx("div", {
      className: styles.ribbon,
      children: ribbonText
    }), statusMessage && version !== 'pillFlag' && /*#__PURE__*/_jsx("span", {
      className: classnames(styles.badge, styles.badgeDesktopOnly),
      children: /*#__PURE__*/_jsx(Text, {
        typog: "bodycopySmall",
        textElement: "span",
        className: styles.badgeText,
        children: statusMessage
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames({
        [styles.containerV2]: version === 'pillFlag'
      }),
      children: [version === 'pillFlag' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CheckboxInput, {
          name: "checkbox",
          checked: check,
          className: styles.checkbox,
          onChange: function onChange() {
            return toggleCheckmark(checkbox.onChange);
          },
          label: checkbox.label
        }), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
          className: styles.image
        }))]
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames({
          [styles.headlineDescriptionWrapperV2]: version === 'pillFlag'
        }),
        children: [headline && /*#__PURE__*/_jsx(Text, {
          typog: "subhead2",
          className: classnames(styles.headline, {
            [styles.headlineV2]: version === 'pillFlag'
          }),
          children: headline
        }), description && /*#__PURE__*/_jsx(Text, {
          typog: "subhead4",
          className: classnames(styles.description, {
            [styles.descriptionV2]: version === 'pillFlag'
          }),
          children: description
        })]
      })]
    }), version === 'pillFlag' && /*#__PURE__*/_jsx(Text, {
      typog: "subhead4",
      className: styles.body,
      children: body
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.ctaBlock, {
        [styles.ctaBlockWithBadge]: !!statusMessage
      }),
      children: version !== 'pillFlag' && /*#__PURE__*/_jsxs(_Fragment, {
        children: [statusMessage && /*#__PURE__*/_jsx("span", {
          className: classnames(styles.badge, styles.badgeMobileOnly),
          children: /*#__PURE__*/_jsx(Text, {
            typog: "bodycopySmall",
            textElement: "span",
            className: styles.badgeText,
            children: statusMessage
          })
        }), ctaText && ctaUrl && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          className: styles.cta,
          url: ctaUrl,
          type: "no-style"
        }, ctaOtherProps), {}, {
          children: /*#__PURE__*/_jsx(Text, {
            typog: "subhead4",
            className: styles.ctaText,
            children: ctaText
          })
        }))]
      })
    })]
  });
};